import { Breadcrumb, Table } from "antd";
import React, { useEffect, useState } from "react";
import { addIcon, editIcon, homeIcon, redTrash } from "../../assets";
import Loader from "../../components/loader/loader";
import { routes } from "../../api/routes";
import { callApi } from "../../api/apiCaller";
import { GreenNotify } from "../../helper/helper";
import { useNavigate } from "react-router-dom";
import OfferModal from "../../components/offerModal/OfferModal";
import SearchComp from "../../components/search/Search";
import DeleteModal from "../../components/deleteModal/DeleteModal";

const OfferEng = () => {
  const [isloading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [getServiceapi, setGetServiceApi] = useState(false);
  const [search, setSearch] = useState("");

  const dummyImage =
    "https://novathreadbucket.s3.amazonaws.com/nova-app-1685176470232-dummy.PNG";
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
  });
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);

  const getAllOffers = () => {
    let getRes = (res) => {
      console.log("res of getAllEngOffers", res);
      setOffers(res?.data?.data || []);
    };

    callApi(
      "GET",
      routes.getAllEngOffers,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };

  // Helper function to parse DD/MM/YYYY format dates
  const parseDate = (dateString) => {
    if (!dateString) return null;
    // Handle DD/MM/YYYY format
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed in JavaScript
      const year = parseInt(parts[2], 10);
      return new Date(year, month, day);
    }
    return new Date(dateString);
  };

  // Helper function to check if date is expired
  const isExpired = (dateString) => {
    const parsedDate = parseDate(dateString);
    if (!parsedDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of day
    return parsedDate < today;
  };

  // Helper function to check if date is active (future)
  const isActive = (dateString) => {
    const parsedDate = parseDate(dateString);
    if (!parsedDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of day
    return parsedDate >= today;
  };

  const handleDeleteClick = (offer) => {
    setSelectedOffer(offer);
    setDeleteModalVisible(true);
  };

  const handleDeleteConfirm = () => {
    if (selectedOffer?._id) {
      deleteOffer(selectedOffer._id);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModalVisible(false);
    setSelectedOffer(null);
  };

  const deleteOffer = (id) => {
    setGetServiceApi(false);
    let getRes = (res) => {
      console.log("res of deleteOffer", res);
      GreenNotify("Offer is deleted successfully");
      setGetServiceApi(true);
      setDeleteModalVisible(false);
      setSelectedOffer(null);
    };

    callApi(
      "DELETE",
      `${routes.deleteOffer}/${id}`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
        setDeleteModalVisible(false);
        setSelectedOffer(null);
      }
    );
  };

  useEffect(() => {
    getAllOffers();
  }, [getServiceapi]);

  const handleTableChange = (pagination, filters, sorter) => {
    setPagination({
      ...pagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  const columns = [
    {
      title: "Store Name",
      dataIndex: "storeName",
      className: "role-name-column-header",
      align: "center",
      sorter: (a, b) => (a.storeName || "").localeCompare(b.storeName || ""),
    },

    {
      title: "Category",
      dataIndex: "category",
      className: "role-name-column-header",
      align: "center",
      width: 300,
      sorter: (a, b) => (a.category || "").localeCompare(b.category || ""),
    },
    {
      title: "Bank",
      dataIndex: "bank",
      className: "role-name-column-header",
      align: "center",
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
          <img
            src={record.bankImage || dummyImage}
            alt={text || "Bank"}
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              objectFit: "cover",
              border: "2px solid #e2e8f0"
            }}
            onError={(e) => {
              e.target.src = dummyImage;
            }}
          />
          <span>{text || "N/A"}</span>
        </div>
      ),
    },
    {
      title: "Expiry Date",
      dataIndex: "expiry",
      className: "role-name-column-header",
      align: "center",
      render: (date) => {
        const parsedDate = parseDate(date);
        if (!parsedDate) return date;
        
        // Format date for display
        const formattedDate = parsedDate.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        
        // Add color coding based on expiry status
        const isExpiredDate = isExpired(date);
        const isActiveDate = isActive(date);
        
        return (
          <span style={{ 
            color: isExpiredDate ? '#ff4d4f' : isActiveDate ? '#52c41a' : '#1890ff',
            fontWeight: 'bold'
          }}>
            {formattedDate}
            {isExpiredDate && ' (Expired)'}
            {isActiveDate && !isExpiredDate && ' (Active)'}
          </span>
        );
      },
      filters: [
        {
          text: "Expired",
          value: "expired",
        },
        {
          text: "Active",
          value: "active",
        },
      ],
      onFilter: (value, record) => {
        if (value === "expired") {
          return isExpired(record.expiry);
        }
        if (value === "active") {
          return isActive(record.expiry);
        }
        return true; // No filtering
      },
    },
    {
      title: "Content",
      dataIndex: "content",
      className: "role-name-column-header",
      align: "center",
    },
    {
      title: "Delete",
      dataIndex: "delete",
      align: "center",
      className: "action-column-header",
    },
  ];

  const data = offers
    ?.filter(
      (item) =>
        (item?.["store name"] &&
          item?.["store name"].toLowerCase().includes(search.toLowerCase())) ||
        (item?.category &&
          item?.category.toLowerCase().includes(search.toLowerCase())) ||
        (item?.employer?.name &&
          item?.employer?.name.toLowerCase().includes(search.toLowerCase()))
    )
    ?.map((item, index) => {
      return {
        key: index,
        storeName: item?.["store name"],
        category: item?.["category"],
        expiry: item?.["expiry date"],
        bank: item?.employer?.name,
        bankImage: item?.employer?.image,

        // edit: (
        //   <div
        //     onClick={() => navigate("/editEmployer", { state: { item: item } })}
        //     style={{ cursor: "pointer" }}
        //   >
        //     <img
        //       style={{ width: "3rem", height: "3rem" }}
        //       src={editIcon}
        //       alt="editIcon"
        //     />
        //   </div>
        // ),
        content: (
          <div
            style={{
              cursor: "pointer",
              fontSize: "15px",
              fontWeight: "bold",
              color: "#000",
            }}
          >
            <OfferModal item={item} />
          </div>
        ),
        delete: (
          <div
            onClick={() => handleDeleteClick(item)}
            className="action-icon-btn delete-btn"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 6H5H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M10 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M14 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Delete</span>
          </div>
        ),
      };
    });

  const getRowClassName = (record, index) => {
    if (index % 2 === 0) {
      return "server-role-even-row";
    }
    return "server-role-odd-row";
  };

  return (
    <div className="modern-page-container">
      <Loader loading={isloading} />
      <DeleteModal
        visible={deleteModalVisible}
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        title="Delete Offer"
        message="Are you sure you want to delete offer"
        itemName={selectedOffer?.["store name"]}
        isLoading={isloading}
      />
      
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-content">
          <div>
            <Breadcrumb
              separator="›"
              className="modern-breadcrumb"
              items={[
                { title: "Dashboard" },
                {
                  title: (
                    <span className="breadcrumb-active">Offers (English)</span>
                  ),
                },
              ]}
            />
            <h1 className="page-title">Offers Management (English)</h1>
            <p className="page-subtitle">Manage and view all English offers</p>
          </div>
          <button
            onClick={() => navigate("/uploadEng")}
            className="modern-add-btn"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M17 8L12 3L7 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 3V15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Upload Offers
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="stats-container">
        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 12V8H6C5.46957 8 4.96086 7.78929 4.58579 7.41421C4.21071 7.03914 4 6.53043 4 6C4 4.9 4.9 4 6 4H18V8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M4 6V18C4 19.1 4.9 20 6 20H20V16H6C4.9 16 4 15.1 4 14V6Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="stat-info">
            <p className="stat-label">Total Offers</p>
            <h3 className="stat-value">{offers?.length || 0}</h3>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M22 4L12 14.01L9 11.01" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="stat-info">
            <p className="stat-label">Active Offers</p>
            <h3 className="stat-value">{offers?.filter(o => isActive(o?.["expiry date"]))?.length || 0}</h3>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2"/>
              <path d="M12 6V12L16 14" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <div className="stat-info">
            <p className="stat-label">Expired Offers</p>
            <h3 className="stat-value">{offers?.filter(o => isExpired(o?.["expiry date"]))?.length || 0}</h3>
          </div>
        </div>
      </div>

      {/* Search and Table Card */}
      <div className="content-card">
        <div className="card-header">
          <h2 className="card-title">All Offers (English)</h2>
          <SearchComp
            placeHolder="Search by store, category, or bank..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="table-container">
          <Table
            rowClassName={getRowClassName}
            columns={columns}
            dataSource={data}
            pagination={{
              ...pagination,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} offers`,
            }}
            onChange={handleTableChange}
            scroll={{ x: 1000 }}
          />
        </div>
      </div>
    </div>
  );
};

export default OfferEng;
